import { useEffect, useState } from 'react';
import { Keyboard, Platform } from 'react-native';

/**
 * Vrai tant que le clavier est à l'écran. Sert à ranger une barre d'action fixe : sur un petit
 * téléphone, clavier ouvert, elle mangerait la moitié de la hauteur utile au champ qu'on remplit.
 * Le web n'émet pas ces événements : la barre y reste.
 */
export function useClavierVisible(): boolean {
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    const [debut, fin] =
      Platform.OS === 'ios' ? (['keyboardWillShow', 'keyboardWillHide'] as const) : (['keyboardDidShow', 'keyboardDidHide'] as const);
    const ouvre = Keyboard.addListener(debut, () => setVisible(true));
    const ferme = Keyboard.addListener(fin, () => setVisible(false));
    return () => {
      ouvre.remove();
      ferme.remove();
    };
  }, []);
  return visible;
}
